const TENANT_STORAGE_KEY = 'helios.portal.tenant';
const TENANT_SLUG = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

/** A routing hint only. The API always resolves and authorizes the identity. */
export function normalizePortalTenant(value: string | null | undefined): string | null {
  const normalized = value?.trim().toLowerCase();
  return normalized && normalized.length <= 100 && TENANT_SLUG.test(normalized) ? normalized : null;
}

export function portalTenantFromSearch(search: string): {
  tenantSlug: string | null;
  invalid: boolean;
} {
  const values = new URLSearchParams(search).getAll('tenant');
  if (values.length === 0) return { tenantSlug: null, invalid: false };
  const tenantSlug = values.length === 1 ? normalizePortalTenant(values[0]) : null;
  return { tenantSlug, invalid: tenantSlug === null };
}

export function storePortalTenant(tenantSlug: string): void {
  const normalized = normalizePortalTenant(tenantSlug);
  if (!normalized) return;
  try {
    window.sessionStorage.setItem(TENANT_STORAGE_KEY, normalized);
  } catch {
    // The URL still carries context when storage is unavailable.
  }
}

export function readPortalTenant(): string | null {
  try {
    return normalizePortalTenant(window.sessionStorage.getItem(TENANT_STORAGE_KEY));
  } catch {
    return null;
  }
}

export function portalLoginPath(search = ''): string {
  const context = portalTenantFromSearch(search);
  // Never silently turn malformed or conflicting URL context into a different
  // contractor's selector. The login form lets the recipient correct it.
  if (context.invalid) return '/portal/login?tenant=invalid_context';
  const tenantSlug = context.tenantSlug ?? readPortalTenant();
  return tenantSlug ? `/portal/login?tenant=${encodeURIComponent(tenantSlug)}` : '/portal/login';
}
